import CustomService from "./CustomService"

export default  CustomService;



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_3/CustomServices/CustomService/index.js